"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROW_HEIGHT = exports.RowColors = exports.StatusColors = void 0;
// todo: theme should be used
exports.StatusColors = {
    optimized: '#54B948',
    warning: '#b97d13',
    error: '#b90005',
};
exports.RowColors = {
    separator: '#C0C0C0',
};
exports.DEFAULT_ROW_HEIGHT = '90px';
//# sourceMappingURL=constants.js.map